import { RuleProps } from 'types/application';
import SUPPORTING_DOCS from './supportingDocs';

export const SECT_EVENT_ON_GOING = 'event-details';

export const EVENT_TYPES_FIELDS = [
    {
        sectionID: SECT_EVENT_ON_GOING,
        sectionName: '',
        fieldList: [
            {
                id: 'event-title',
                apiID: 'Title',
                label: 'Event Title',
                type: 'longText',
                rule: {
                    disabled: true,
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (currentValue) {
                            const result = /(\b((https?|ftp|file):\/\/|(www\.))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig.test(
                                currentValue as string
                            );
                            if (result) return 'URL Not Allowed in Title.';
                        }

                        return true;
                    }
                },
                span: 12
            },
            {
                id: 'event-type',
                apiID: 'IMDA-IRIS-Work-Arts-Type',
                label: 'Event Type',
                type: 'text',
                rule: { disabled: true }
            },
            {
                id: 'event-sub-type',
                apiID: 'SubType',
                label: 'Event Sub Type',
                type: 'text',
                rule: { disabled: true }
            },
            {
                id: 'docs-list',
                type: 'helperList',
                span: 12,
                preField: {
                    id: 'link',
                    label: 'Link to Supporting Documents',
                    placeholder: 'Eg: https://yourdocumentlink.com/',
                    type: 'text'
                },
                mainField: {
                    id: 'docs',
                    preventDelete: true,
                    label: 'Update Supporting Documents',
                    type: 'file',
                    category: 'SupportingDocuments',
                    fileTypes: ['.jpeg', '.jpg', '.png', '.bmp', '.mp4', '.mpeg', '.mov', '.pdf', '.xls', '.doc', '.xlsx', '.docx'],
                    mimeTypes: [
                        'application/pdf',
                        'application/vnd.ms-excel',
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'image/jpeg',
                        'image/jpg',
                        'image/png',
                        'image/bmp',
                        'video/quicktime',
                        'video/mp4',
                        'video/mpeg'
                    ]
                },
                customList: SUPPORTING_DOCS,
                customListExpect: [`${SECT_EVENT_ON_GOING}-event-type`, `${SECT_EVENT_ON_GOING}-event-sub-type`]
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'longText',
                textRows: 4,
                span: 12
            },
            {
                id: 'event-date-time',
                label: '',
                type: ''
            }
        ]
    }
];
